// extracted by mini-css-extract-plugin
export default {"otp_open":"ForgotPasswordForm_otp_open__W0Zpu","errorMsg":"ForgotPasswordForm_errorMsg__PIN5H"};